<template>
    <div>
        <div class="recommend-account-opening-box">
            <div><img class="compnay-default-icon" alt="" src="./images/logo.png"></div>
            <div class="compnay-text-icon-box"><img class="compnay-text-icon" alt="" src="./images/tittle.png"></div>
            <div id="accountApply" v-show="accountApply">
              <div class="recommend-account-text">赶紧输入信息，领取资格吧</div>
              <div class="input-name">
                <img class="input-img" src="./images/user.png" alt="">
                <input type="text" name="" id="clientName" v-model="clientName" maxlength="11" placeholder="请输入真实姓名" >
              </div>
              <div class="input-name">
                <img class="input-img" src="./images/phone.png" alt="">
                <input type="tel" id="mobile" maxlength="11" name="phone" v-model="tel" placeholder="请输入手机号码" >
              </div>
              <div class="input-name">
                <img class="input-img" src="./images/message.png" alt="">
                <input type="tel" name="" id="verifyCode" v-model="verifyCode" >
                <button type="button" id="getyzm" class="code-button"  @click="getyzm" v-show="getYZM">获取验证码</button>
                <div class="yzmbutton code-button" id="cxhq" v-show="!getYZM">重新获取{{timeText}}s</div>
              </div>
              <div class="submit-text">申请成功后，请留意查收开户操作指引短信,</div>
              <div class="submit-text">并下载东航期货App完成开户。</div>
              <div class="submit"><button type="button" class="submit-button" @click="apply">立即申请</button></div>
              <div class="submit-text mtb-10">软件下载请点击下方按钮</div>
            </div>
            <div id="accountApplyShow" v-show="!accountApply">
              <div class="success-icon-box"><img src="./images/success.png" class="success-icon" alt=""></div>
              <div class="success-text">您已领取成功</div>
              <div class="apply-text">请下载并使用东航金融APP完成开户</div>
            </div>
            <div class="dowload-phone-icon">
              <a target="_blank" @click="Download"><img class="phone-icon-img phone-icon-img-android" src="./images/android.png" alt=""></a>
              <a target="_blank" @click="Download"><img class="phone-icon-img phone-icon-img-ios" src="./images/ios.png" alt=""></a>
            </div>
            <div class="extra-welfare">
              <div class="extra-welfare-box">
                <div class="welfare-title"><span class="icon"></span><span>免费期货靓号</span></div>
                <div class="welfare-context">
                  <span class="yellow-icon"></span>
                  <span>如尾号「666」、「888」等期货靓号，数量有限，先到先得!</span>
                  <div class="special-text">(温馨提示:请在提交资料后7日内完成开户哦)</div>
                </div>
                <div class="welfare-title welfare-title-jifen"><span class="icon"></span><span> 乐享积分换好礼</span></div>
                <div class="welfare-context">
                  <span class="yellow-icon"></span>
                  <span>参与APP内活动即有机会赢取积分奖励。更有机票、话费等各类积分好礼送不停！</span>
                </div>
              </div>
              <div class="extra-welfare-box extra-welfare-jifen-box">
                <div class="company-introduce">
                  <div class="compnay-img"><img class="company-icon" alt="" src="./images/kiiik.png"></div>
                  <div class="company-text">东航期货，成立于1995年，总部设于上海，是中国东方航空集团有限公司下属东航金控有限责任公司的全资子公司。
                  </div>
                </div>
                <div class="split-line"></div>
                <div class="company-introduce">
                  <div class="compnay-img"><img class="company-icon" alt="" src="./images/lhmj.png"></div>
                  <div class="company-text">公司是上世纪首批由中国证监会核准成立的期货公司之一，国内知名期货实盘大赛“蓝海密剑”主办方。
                  </div>
                </div>
              </div>
            </div>
            <div class="website">从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站（www.csrc.gov.cn）查询。</div>
            <div class="website">——投资有风险 入市需谨慎——</div>
            <div class="website"><img class="ending-logo" src="./images/logo.png" alt=""></div>
            <div class="website">本活动最终解释权仅归东航期货所有</div>
            <div class="website jinhao">沪ICP备14006107号-1 沪公网安备31011202001150号</div>
        </div>
        <div id="toast" v-show="toastShow">
          {{toastText}}
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import ajax from '@/common/ajax/ajax'
export default {
    data(){
        return {
            accountApply: true,
            getYZM: true,
            toastShow: false,
            tel:'',
            verifyCode:'',
            clientName:'',
            timeText:30,
            toastText:'请求失败，请稍后再试！',
            brokerSec:'',
            proID:''
        }
    },
    created(){
        this.getAppParams()
        this.judgePhoneType()
    },
    mounted(){},
    methods:{
      Download(){
        this.$router.push('/download')
      },
      getAppParams(){
          let url = window.location.href; //获取url中"?"符后的字串
          const index=url.lastIndexOf("\?");
          const urlSplice =  url.substring(index+1,url.length);
        console.log(urlSplice,'urlSplice');
        const strs = urlSplice.split("&"); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        const obj ={}
        strs.map(el=>{
            const indexEl=el.lastIndexOf("\=");
            const urlSpliceEl =  el.substring(indexEl+1,el.length);
            const urlSpliceElKey =  el.substring(0,indexEl);
            const objKeyValue = urlSpliceEl
            const objKey = urlSpliceElKey
            if(objKey === 'brokerSec'){
                this.brokerSec = decodeURI(`${objKeyValue}`)
            } else
            if(objKey === 'proID'){
                this.proID = objKeyValue
            }
        })
        console.log(strs,'strs');
        // alert(strs[1]);   //直接弹出第一个参数 （如果有多个参数 还要进行循环的）
      },
      judgePhoneType(){
                //手机系统类型
                var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    var system = "IOS";
                }else{
                    var system = "Android";
                }

                //浏览器判断
                var ua = navigator.userAgent.toLowerCase();
                var btype;
                if(ua.match(/MicroMessenger\/[0-9]/i)){
                    btype = "微信";
                }else if(ua.match(/QQ\/[0-9]/i)){
                    btype = "QQ";
                }else if(ua.indexOf('mqqbrowser')> -1){
                    btype = "QQ浏览器";
                }else if(ua.indexOf('opera')> -1){
                    btype = "Opera浏览器";
                }else if(ua.indexOf('ucbrowser')> -1){
                    btype = "UC浏览器";
                }else if(ua.indexOf('baiduboxapp')> -1){
                    btype = "百度浏览器";
                }else if(ua.indexOf('chrome')> -1){
                    btype = "chrome浏览器";
                }else if(ua.indexOf('safari')> -1){
                    btype = "Safari浏览器";
                }else if(ua.indexOf('firefox')> -1){
                    btype = "Firefox浏览器";
                }else{
                    btype = "其它";
                }
                setTimeout(()=> {
                    var repo = "QiniuPandoraQiniuPandora";
                    var token = "TwFQY3_TmvcIpTqfFW4W6fCfFwN1XiUpJdtCYPhW:yOTlzTrM5VKFHN1L_yyxYMcVLBM=:eyJyZXNvdXJjZSI6Ii92Mi9yZXBvcy9hcHBOZXcvZGF0YSIsImV4cGlyZXMiOjE4Nzc1Nzg5ODIsImNvbnRlbnRNRDUiOiIiLCJjb250ZW50VHlwZSI6InRleHQvcGxhaW4iLCJoZWFkZXJzIjoiIiwibWV0aG9kIjoiUE9TVCJ9";
                    var data = [{"system": system, "type": btype,"ctype":"老访问"}];
                    // QiniuPandora.pushToPandoraPipeline(repo, token, data);
                }, 200);
        },
				checkMobile() {
				  let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				  if( !reg.test(this.tel)) {
				    return false
				  }
				  return true
				},
				checkName() {
					this.clientName = this.clientName.replace(/\s/g, '')
					let reg = /[0-9A-Za-z]/ig
					if(this.clientName.length > 10 || this.clientName.length < 2) {
						alert("真实姓名需在2-10位！")
						return false
					}
					if(reg.test(this.clientName)) {
						alert("请输入真实姓名！")
						return false
					}
					return true
			 },
      getyzm(){
            if(!this.tel || !this.checkMobile()){
                alert("请填写正确的手机号！");
                return;
            }
            this.getYZM = false
            let i = 30;
            const clock = setInterval(()=>{
            i--;
            if(i == 0){
                i = 30;
                clearInterval(clock);
                this.getYZM = true
            }
            this.timeText = i
        },1000)
            const senddata = {
                mobile: this.tel,
                type:2
            }
            ajax.sendVerifyCode(senddata).then(res=>{
                this.toast(res.data.resultMessage);
            }).catch(()=>{
                this.toast("请求失败，请稍后再试！");
            })
     },
      apply(){
				if(!this.clientName){
					alert("请填写真实姓名");
					return;
				}
				if(!this.checkName()){
					return
				}
				if(!this.tel || !this.checkMobile()){
					alert("请填写正确的手机号！");
					return;
				}
				console.log(this.verifyCode,'this.verifyCode');
				if(!this.verifyCode){
					alert("请填写验证码！");
					return;
				}
				const deviceId = 'appxctjsbhzdy'
				const aa = 'ZGwqFCOeMeh8et2pj7bjug=='
				const bb = 'APA02'
				ajax.memberLoginByVerifyCode(this.tel,this.verifyCode,deviceId,this.brokerSec,this.clientName,this.proID).then(res=>{
						this.toast(res.data.resultMessage);
						if(res.data.resultStatus === '0'){
								this.accountApply = false
						}
				}).catch(()=>{
						this.toast("请求失败，请稍后再试！");
				})
			},
			toast(text) {
					this.toastShow = true
					this.toastText = text;
					setTimeout(()=> {
					this.toastShow = false
					} ,2000)
			}
    }
}
</script>
<style src="./index.css" scoped></style>



// WEBPACK FOOTER //
// index.vue?d395caac